import { FC } from "react";
import { CreateButton, EditButton, ListButton, ShowActionsProps, TopToolbar, useResourceDefinition, useShowContext } from "react-admin";
import { bidResource } from "../..";
import { FILTER_DIRECTION, PermissionBehavior, ProcEntityRecordStatus } from "../../../../common";
import { usePermissionsCheck } from "../../../../lib/core";

const sanitizeRestProps = ({
    basePath,
    className,
    hasEdit,
    hasList,
    resource,
    ...rest
}: any) => rest;

const BidCrudShowActions:FC<ShowActionsProps> = ({ className, ...rest }) => {
    const { record } = useShowContext(rest);

    const { hasList, hasEdit, hasCreate } = useResourceDefinition(rest);
    const { hasPermissionAccess} = usePermissionsCheck();
    const canProcure = hasPermissionAccess(PermissionBehavior.CAN_PROCURE);
    const canCreate = hasPermissionAccess(bidResource?.options?.allowedPermissions?.create);
    const direction = canProcure?FILTER_DIRECTION.RECEIVED:FILTER_DIRECTION.SENT;
    
    const status = record?.procureStatus;
    const isStatusWaitingDraft = status === ProcEntityRecordStatus.DRAFT;

    return (
        <TopToolbar className={className} {...sanitizeRestProps(rest)}>
            {hasList && <ListButton basePath={`/bids?filter={"direction":"${direction}"}`}/>}
            {hasEdit && isStatusWaitingDraft && <EditButton basePath="/bids" record={record} />}
            {hasCreate && canCreate && <CreateButton basePath="/bids"/>}
        </TopToolbar>
    )
}

export { BidCrudShowActions }